const AuthReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN": {
      return {
        token: action.payload.token,
        userID: action.payload.userID,
        userName: action.payload.userName,
        isAdmin: action.payload.isAdmin,
      };
    }

    case "LOGOUT": {
      return {
        token: null,
        userID: null,
        userName: null,
        isAdmin: null,
        phoneNumber: null,
      };
    }

    default:
      return state;
  }
};

export default AuthReducer;
